import { render, staticRenderFns } from "./IconListBlock.vue?vue&type=template&id=c6d4af6c&"
import script from "./IconListBlock.vue?vue&type=script&lang=js&"
export * from "./IconListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports